export default __webpack_public_path__ + "KaTeX_Size2-Regular.635e9324cc2ad9bdbfb1d307c1c9c5b2.woff";